import React from "react";
import dateFormat from "dateformat";

import app_params from "../../config/params";

const Footer = (props) => {
  var now = new Date();
  return (
    <footer className={`text-center text-lg-start theme-footer`}>
      <section className="border-bottom">
        <div className="container text-center text-md-start mt-5">
          <div className="row">
            <div className="col-12 col-lg-6 mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Contacto</h6>
              <p>
                <i className="fas fa-home me-3"></i>  Calle Rodolfo Robles 29-99 Zona 1, Quetzaltenango, Quetzaltenango, Guatemala
              </p>
              <p>
                <a href="mailto:biblioteca@cunoc.edu.gt ">
                  <i className="fas fa-envelope me-3"></i>
                   biblioteca@cunoc.edu.gt  
                </a>
              </p>
              <p>
                <a href="tel:7873-0000">
                  <i className="fas fa-phone-alt me-3"></i>
                  (502) 7873-0000
                </a>
                <span> ext. 2243</span>
              </p>
              {/* <p>
                <a href="tel:22323544">
                  <i className="fas fa-phone-alt me-3"></i>
                  (502) 22323544
                </a>
              </p> */}
            </div>
            <div className="col-12 col-lg-6 mx-auto mb-4 text-center">
              <h6 className="text-uppercase fw-bold mb-4">
              Biblioteca "Francisco Monroy Paredes"
              </h6>
              {/* <p>Comparte en tu red social favorita</p>
              <div>
                <a
                  href="https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2Facademiageohist.org.gt%2Fpropositos-y-fines%2F&linkname=Prop%C3%B3sitos%20y%20Fines&linknote="
                  className="me-4 text-reset"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a> */}
                {/* <a
                  href="https://www.facebook.com/CienciasEconomicasUsac/#"
                  className="me-4 text-reset"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-twitter"></i>
                </a> */}
                {/* <a
                  href="https://www.addtoany.com/add_to/linkedin?linkurl=https%3A%2F%2Facademiageohist.org.gt%2Fpropositos-y-fines%2F&linkname=Prop%C3%B3sitos%20y%20Fines&linknote="
                  className="me-4 text-reset"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a> 
                <a
                  href="http://www.cas.usac.edu.gt/"
                  className="me-4 text-reset"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa fa-globe" aria-hidden="true"></i>
                </a> 
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <section className="d-lg-flex flex-row justify-content-center p-4">
        <div className="d-flex flex-row justify-content-center mx-lg-5">
          <span className="glifos-font">GLIFOS - library</span>
          <span className="ms-1">ver. {app_params.version}</span>
        </div>
        <div className="d-flex flex-row justify-content-center mt-3 mt-lg-0 mx-lg-5">
          Copyright &copy; 2000 - {dateFormat(now, "yyyy")} Infolib, S.A.
        </div>
        <div className="d-flex flex-column justify-content-center mt-3 mt-lg-0 mx-lg-5">
          <div className="d-flex flex-row justify-content-center">
            <a href="https://glifos.com" target="_blank" rel="noreferrer">
              <img
                src={`${app_params.basepath}/assets/logos/poweredByGLIFOS.png`}
                alt="poweredByGLIFOS"
                width="63"
                height="30"
                className="rounded"
              />
            </a>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
